export default {
  insertMenuTitle: 'Menu wyrażeń',
};
